<template>
  <div class="ipa-text-root" v-html="html"></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    html: {
      type: String
    },
  },
  setup(_){
  }
})
</script>

<style lang="scss" scoped>
.ipa-text-root {
  word-break: keep-all;
}
.ipa-text-root * {
  font-family: Roboto, sans-serif;
}
.theme--light .ipa-text-root ::v-deep span {
  color: var(--light-readonly-text)
} 
.theme--dark .ipa-text-root ::v-deep span {
  color: var(--dark-readonly-text)
} 
.ipa-text-root ::v-deep > .symbol .non-symbol,
.ipa-text-root ::v-deep > .non-symbol{
  font-size: 0.5em;
  margin: 0px 2px;
  &,
  span {
    color: #888888; 
  }
}
.ipa-text-root pre {
  display: inline-block;
  word-spacing: 0;
}
</style>
